import i18n from '../i18n';
import type { Report } from '../types/api';

export function reportLabel(report?: Pick<Report, 'workflowType' | 'submittedAt' | 'id'> | null): string {
    if (!report) {
        return '';
    }
    const workflow = report.workflowType?.trim();
    if (workflow) {
        return workflow;
    }
    if (report.id) {
        return report.id.slice(0, 8);
    }
    return i18n.t('entities.report');
}

export function reportSubmissionLabel(report?: Pick<Report, 'submittedAt'> | null): string {
    if (!report?.submittedAt) {
        return i18n.t('common.draft');
    }
    return new Date(report.submittedAt).toLocaleString();
}
